module.exports = __webpack_public_path__ + "static/media/arrow-coinera.f2b2011b.svg";